import { render, staticRenderFns } from "./BpmProcessTrackModal.vue?vue&type=template&id=2225d6fa&scoped=true&"
import script from "./BpmProcessTrackModal.vue?vue&type=script&lang=js&"
export * from "./BpmProcessTrackModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmProcessTrackModal.vue?vue&type=style&index=0&id=2225d6fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225d6fa",
  null
  
)

export default component.exports